@if (!isLoaded) {
  <div class="tree-view"
    >
    Vide
  </div>
}
@if (isLoaded) {
  <div class="tree-view"
    >
    <ng-container *ngTemplateOutlet="treeViewList; context:{ $implicit: treeModel.items, role: 'tree', treeid: treeModel.treeNodeId, parentid: 'root', lid: 0 }">
    </ng-container>
  </div>
}
<ng-template #treeViewList
  let-list
  let-role='role'
  let-treeid="treeid"
  let-parentid="parentid"
  let-lid="lid">
  @if (isChildrenExists(list)) {
    <ul [attr.role]="role"
      id="treeView_ul_{{treeid}}_{{parentid}}"
      [attr.aria-labelledby]="this['tree_view_'+treeid]"
      #ultags>
      @for (item of list; track item; let i = $index) {
        <li
          [id]="getTreeItemId(item,treeid)"
          [attr.data-code]="item[treeModel.cid]"
          [attr.data-childcount]="getChildCount(item)"
          [attr.data-index]="i"
          [attr.data-first]="i === 0 ? 1 : 0"
          [attr.data-last]="i === list.length - 1 ? 1 : 0"
          role="treeitem"
          (keydown)="executeKeydown($event)"
          [tabindex]="setTabIndexOnLoad(role,i)"
          #options
          [attr.aria-expanded]="collapsedState(item)">
          <span class="tree-item-label"
            [class.hover]="isLeaf(item) && hoverLeaves"
            [attr.data-role]="isLeaf(item) ? 'leaf' : role"
            (click)="toggleNode(item)"
            (mouseenter)="onMouseenter(item)"
            (mouseleave)="onMouseleave(item)">
            @if (!isLeaf(item)) {
              <i
                aria-hidden="true"
                [ngClass]="getExpandCollapseClass(item)"
                [id]="getIconId(item)"
                #icons>
              </i>
            }
            @if (isLeaf(item) && getLeafClass(item)) {
              <i
                aria-hidden="true"
                [ngClass]="getLeafClass(item)"
                [id]="getIconId(item)"
                #icons>
              </i>
            }
            @if (hasTemplate(item)) {
              <ng-container *ngTemplateOutlet="getTemplate(item); context:{ $implicit: item.data}">
              </ng-container>
            } @else {
              {{item[treeModel.lid]}}
            }
          </span>
          <ng-container *ngTemplateOutlet="treeViewList; context:{ $implicit: item.children, role: 'group', treeid: treeModel.treeNodeId, parentid: item[treeModel.cid], lid: lid + 1 }">
          </ng-container>
        </li>
      }
    </ul>
  }
</ng-template>
